import {Component, OnInit, input, model, viewChild, output, signal, DestroyRef, inject, ChangeDetectionStrategy} from "@angular/core"
import {InputContainerComponent} from "@common/components/inputs/input-container/input-container.component"
import {NativeInputTextComponent} from "@common/components/inputs/native/native-input-text/native-input-text.component"
import {debounceTime, Subject, tap} from "rxjs"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-search",
    templateUrl: "./search.component.html",
    styleUrls: ["./search.component.scss"],
    imports: [InputContainerComponent, NativeInputTextComponent],
})
export class SearchComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef)
    readonly $value = model("", {alias: "value"})
    readonly $placeholder = input("Search...", {alias: "placeholder"})
    readonly inputStarted = output<string>()
    readonly valueChange = output<string>()
    readonly focus = output<FocusEvent>()
    readonly blur = output<FocusEvent>()
    readonly $searchTextChanged = signal<Subject<string>>(new Subject<string>())
    readonly $nativeInput = viewChild.required(NativeInputTextComponent)

    ngOnInit(): void {
        this.$searchTextChanged()
            .pipe(
                tap((newValue) => {
                    this.$value.set(newValue)
                }),
                tap((newValue) => this.inputStarted.emit(newValue)),
                debounceTime(300),
                // we need to emit even if the old value is the same as the new value
                // because the content might already have been replaced by placeholders
                // e.g. when changing `text` to `text2` and then back to `text` within the debounce time
                // distinctUntilChanged(),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe((text: string) => {
                this.valueChange.emit(text)
            })
    }

    updateValue(value: string) {
        this.$nativeInput().updateValue(value)
    }
}
